/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-07-29T14:37:11.979
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportFinancialOutsideStorageContract,
	listReportFinancialOutsideStorageContractInit,
	listReportFinancialOutsideStorageContractByAuthorizations,
	deleteReportFinancialOutsideStorageContract
	
} from '@api/report/ReportFinancialOutsideStorageContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportFinancialOutsideStorageContract({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialOutsideStorageContract(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialOutsideStorageContractByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialOutsideStorageContractByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialOutsideStorageContractInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialOutsideStorageContractInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportFinancialOutsideStorageContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialOutsideStorageContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
